import firebase from '@/firebase/firebase';
let db = firebase.firestore();

export default function (collectionName) {
    return {
        data: () => {
            return {
                busy: false,
            }
        },
        computed: {
            dbRef () {
                let companyId = this.$store.getters.getCompanyID;
                return db.collection(`/company/${companyId}/${collectionName}`);
            }
        },
        methods: {
            async get () {
                try {
                    this.busy = true;
                    
                    this.dbRef.onSnapshot((snapshot) => {
                            snapshot.docChanges().forEach(change => {
                                const doc = { id: change.doc.id, ...change.doc.data() };
                                if (this.$refs.organizer) {
                                    if (change.type === "added")
                                        this.$refs.organizer.add(doc);
                                    else
                                        this.$refs.organizer.onChange(doc);
                                }
                            })
                        })
                } catch (err) {
                    this.$store.commit('setError', err);
                } finally {
                    this.busy = false;
                }
            },
            async saveEditing (item, newDescription) {
                try {
                    this.busy = true;
    
                    await this.dbRef.doc(item.id)
                            .update({
                                description: newDescription
                            });
                } catch (err) {
                    this.$store.commit('setError', err);
                } finally {
                    this.busy = false;
                }
            },
            async disableItem (item) {
                try {
                    this.busy = true;
                    await this.dbRef.doc(item.id)
                            .update({
                                active: false
                            });
                    this.$notification.success({
                        style: 'z-index: 9999999',
                        message: this.$t('success'),
                        description: 'Produto removido'
                    });
                } catch (err) {
                    this.$store.commit('setError', err);
                } finally {
                    this.busy = false;
                }
            },
            async saveOrder (list) {
                var batch = db.batch();

                list.filter((m, i) => m.order !== i).forEach((item) => {
                    let ref = this.dbRef.doc(item.id);
                    const index = list.findIndex(m => item.id === m.id);
                    batch.update(ref, { order: index });
                });
                await batch.commit();
            }
        },
    }
}